




















import { Component, Vue, Prop } from 'nuxt-property-decorator';
import HeaderMenuNotificationsCardGrid from '@/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotificationsCard/HeaderMenuNotificationsCardGrid/HeaderMenuNotificationsCardGrid.vue';
import type { Notification, Post, Anonymous } from '@/types/graphql';

@Component<HeaderMenuNotificationsCardRecommendedPost>({
  name: 'HeaderMenuNotificationsCardRecommendedPost',
  components: {
    HeaderMenuNotificationsCardGrid,
  },
})
export default class HeaderMenuNotificationsCardRecommendedPost extends Vue {
  @Prop({ required: true }) notification!: Notification;

  get referenceable(): Post {
    return this.notification.referenceable as Post;
  }

  get title(): string {
    if (this.$auth.user?.position) {
      const { position } = this.$auth.user;

      return `Popular with ${position}${position.endsWith('s') ? '' : 's'}`;
    }

    return 'Recommended for you';
  }

  get username(): string {
    if (!this.referenceable.author) {
      return 'Deactivated User';
    }
    if (this.referenceable.author.__typename == 'Public') {
      return `${this.referenceable.author.firstname} ${this.referenceable.author.lastname}`;
    }
    return (this.referenceable.author as Anonymous).username ?? '';
  }

  get titleClass(): Record<string, boolean> {
    return {
      'header-menu-notifications-card-recommended__title': true,
      'header-menu-notifications-card-recommended__title--read': !!this.notification.readAt,
    };
  }
}
